// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3A9MY","productName":"Table_productName__3-_6P"};